import type { OrderHealthStatus, OrderTrackingOrder, OrderTrackingOrderMetrics } from '@/services/orderTracking/orderTracking.types';

const HEALTH_SORT_ORDER: Record<OrderHealthStatus, number> = {
  critical: 0,
  late: 1,
  at_risk: 2,
  on_time: 3,
  partial: 3,
  received: 5,
  cancelled: 6,
};

export type EnrichedOrder = OrderTrackingOrder & { metrics: OrderTrackingOrderMetrics };

export function sortOrdersBySeverity(orders: EnrichedOrder[]): EnrichedOrder[] {
  return [...orders].sort((a, b) => {
    const healthDiff =
      HEALTH_SORT_ORDER[a.metrics.healthStatus] - HEALTH_SORT_ORDER[b.metrics.healthStatus];
    if (healthDiff !== 0) return healthDiff;
    const lateDiff = (b.metrics.daysLate ?? 0) - (a.metrics.daysLate ?? 0);
    if (lateDiff !== 0) return lateDiff;
    return a.orderNumber.localeCompare(b.orderNumber);
  });
}

/** Timestamp para ordenar por fecha esperada; sin fecha al final. */
export function getOrderExpectedDateSortValue(order: OrderTrackingOrder): number {
  const raw = order.expectedDate ?? order.effectiveDeadline;
  if (!raw) return Number.MAX_SAFE_INTEGER;
  const ts = new Date(raw).getTime();
  return Number.isNaN(ts) ? Number.MAX_SAFE_INTEGER : ts;
}
